module.exports = [{
  date: '2026-09-07',
  version: '2.10.0',
  description: '<ul>' + '<li>LHVO-5514 Mandatory activities on app to unlock 1:1 coaching</li>' + '</ul>'
}, {
  date: '2026-08-10',
  version: '2.9.0',
  description: '<ul>' + '<li>LHVO-5496 Cookie consent banner : Admin Portal - Add banner</li>' + '</ul>'
}, {
  date: '2026-06-18',
  version: '2.8.0',
  description: '<ul>' + '<li>LHVO-5462 TIAA 1:1 Coaching Integration</li>' + '</ul>'
}, {
  date: '2026-06-18',
  version: '2.7.0',
  description: '<ul>' + '<li>LHVO-5451 Disable Google Analytics</li>' + '</ul>'
}, {
  date: '2026-04',
  version: '2.6.0',
  description: '<ul>' + '<li>LHVO-5373 Access control of LHF producers</li>' + '</ul>'
}, {
  date: '2025-08',
  version: '2.5.0',
  description: '<ul>' + '<li>LHVO-5143 LifePassport company logo : Admin Portal - Organization List page</li>' + '<li>LHVO-5144 LifePassport company logo : Admin Portal - Organization Edit page</li>' + '<li>LHVO-5145 LifePassport company logo : Admin Portal - Organization Create page</li>' + '<li>LHVO-5140 LifePassport company logo : Admin Portal - Display organization name in User List page</li>' + '<li>LHVO-5156 LifePassport company logo : Admin Portal - Add Assign Users button to Organization List page</li>' + '<li>LHVO-5142 LifePassport company logo : Admin Portal - Add organization input in User Edit page</li>' + '</ul>'
}, {
  date: '2025-06',
  version: '2.4.3',
  description: '<ul>' + '<li>LHVO-5242 Create new rubric tags in the Admin Portal</li>' + '</ul>'
}, {
  date: '2024-10',
  version: '2.4.0',
  description: '<ul>' + '<li>LHVO-5020 Remove Hike Producer setting : Admin Portal</li>' + '</ul>'
}, {
  date: '2024-07-30',
  version: '2.3.0',
  description: '<ul>' + '<li>LHVO-4397 Improved asset-management within the Admin Portal</li>' + '<li>LHVO-4992 unctional: Activation code generation in the Admin Portal does not align with the user’s input.</li>' + '<li>LHVO-4974 Annotation Tool for TASs : [Function B] Admin Portal - Add TAS Admin Role</li>' + '</ul>'
}, {
  date: '2024-06-19',
  version: '2.2.1',
  description: 'LHVO-4940 Update Node.js and Lodash version'
}, {
  date: 'TBC',
  version: '2.2.0',
  description: 'TBC'
}, {
  date: '2023-12-06',
  version: '2.1.0',
  description: '<ul>' + '<li>Admin Portal - Fix delete user API request</li>' + '<li>Automated Email calendar links : Admin Portal - Update email templates.</li>' + '</ul>'
}, {
  date: '2023-10-20',
  version: '2.0.3',
  description: '<ul>' + '<li>Replace excel upload with csv : Admin Portal - Hike enrollment list.</li>' + '<li>Replace excel upload with csv : Admin Portal - Loop enrollment list.</li>' + '<li>Automated Email : Admin Portal - New No Email rule set.</li>' + '<li>Amend form fields to Given name and Surname : Admin Portal - Amend in various locations.</li>' + '<li>Revise Activation QR Code : Admin Portal - Generate QR Code by activation URL.</li>' + '</ul>'
}, {
  date: '2023-09-14',
  version: '2.0.2',
  description: '<ul>' + '<li>Update timezone picker.</li>' + '</ul>'
}, {
  date: '2023-08-31',
  version: '2.0.1',
  description: '<ul>' + '<li>Check Enable 720 Survey while report Show 720 Team Survey Data is enabled.</li>' + '<li>Admin Portal - Add tooltips at Hike edit page.</li>' + '<li>Admin Portal - Display long PI tag.</li>' + '<li>Admin Portal - Hike - Display the extra error message if creating the new hike after login the admin portal first time in the new browser.</li>' + '</ul>'
}, {
  date: '2023-08-17',
  version: '2.0.0.1',
  description: '<ul>' + '<li>Various enhancements and bug fixes after v2.0.</li>' + '</ul>'
}, {
  date: '2023-08-10',
  version: '2.0.0',
  description: '<ul>' + '<li>In-house Enrollment : Add PID for Hike.</li>' + '<li>In-house Enrollment : Add PID for Loop.</li>' + '<li>In-house Enrollment : Add Client Staff role in User Setting.</li>' + '<li>In-house Enrollment : Display enrolled by in Loop Participants page.</li>' + '<li>In-house Enrollment : Display enrolled by in Hike Participants page.</li>' + '<li>In-house Enrollment : Add send enrollment form button in Hike.</li>' + '<li>In-house Enrollment : Add send enrollment form button in Loop.</li>' + '<li>In-house Enrollment : Support Client POC role and enrollment quota in Hike.</li>' + '<li>In-house Enrollment : Support Client POC role and enrollment quota in Loop.</li>' + '<li>Automated Email Phase 2 : Loop email settings page.</li>' + '<li>Automated Email Phase 2 : Hike email settings page.</li>' + '<li>Loop : Show error when user is being unenrolled from a Hike which is in a Loop.</li>' + '<li>Loop : Copy Loop function.</li>' + '<li>Loop : Loop enrollment list page and enroll by excel upload.</li>' + '<li>Loop : Add popup message to externalAction program.</li>' + '<li>Loop : Maximum one Hike in Enrolment program.</li>' + '<li>Display Rater Credits in Invoice Report : Admin Portal.</li>' + '<li>Dial Test Exercise : Allow select moment component in Benchmark and Summit .</li>' + '<li>In-app feedback : Support new survey type.</li>' + '<li>Use lh-js-common-lib for PI tag mapping.</li>' + '<li>Dial Test Exercise : New dialtestexercise Hike component.</li>' + '<li>Peer Dial Test Multiple Raters : Support min and max raters setting.</li>' + '</ul>'
}, {
  date: '2023-03-20',
  version: '1.5.0',
  description: '<ul>' + '<li>Show timezone picker in Development and Staging environment.</li>' + '<li>Update PI tag in Hike > Report.</li>' + '<li>Standardize range color : Update Hike category dropdown.</li>' + '</ul>'
}, {
  date: '2022-12-22',
  version: '1.4.0',
  description: '<ul>' + '<li>Make Hike activity component title required.</li>' + '<li>Remove Hike stage resource setting.</li>' + '<li>Update downstream domains to xxx.lifehikes.com.</li>' + '<li>Add a hint for Hikes which started 3 months from now.</li>' + '<li>Support search by ID in Event, Loop, Hike.</li>' + '<li>Minor enhancement on Loop setting page.</li>' + '<li>Fix TAS rating loading problem.</li>' + '</ul>'
}, {
  date: '2022-09-17',
  version: '1.3.1',
  description: '<ul>' + '<li>Hide all "Baseline" related element from Admin-portal.</li>' + '<li>Deprecate isLoop : Remove isLoop related UI components.</li>' + '<li>Deprecate isLoop : API - Remove isLoop related APIs.</li>' + '<li>Bug fixes : Participant role users can see the Loops option after logging in.</li>' + '</ul>'
}, {
  date: '2022-08-15',
  version: '1.3.0',
  description: '<ul>' + '<li>Survey: Add a new survey feature and update the Hike setting to support the new in-house survey.</li>' + '<li>Add Loop schedule view.</li>' + '<li>Learning Passport: Add a new upload Typeform survey result function to support Learning Passport Report.</li>' + '</ul>'
}, {
  date: '2022-05-22',
  version: '1.2.11',
  description: '<ul>' + '<li>Bug fixes</li>' + '</ul>'
}, {
  date: '2022-04-27',
  version: '1.2.10',
  description: '<ul>' + '<li>720 Report - improvements</li>' + '</ul>'
}, {
  date: '2022-02-22',
  version: '1.2.9',
  description: '<ul>' + '<li>720 Report</li>' + '<li>SSO Login</li>' + '</ul>'
}, {
  date: '2021-12-10',
  version: '1.2.7',
  description: '<ul>' + '<li>Report Enhancement</li>' + '<li>Un-enroll participant in Training</li>' + '<li>Change Portal Company Logo</li>' + '</ul>'
}, {
  date: '2021-09-17',
  version: '1.2.6',
  description: '<ul>' + '<li>Bug Fix</li>' + '</ul>'
}, {
  date: '2021-09-17',
  version: '1.2.5',
  description: '<ul>' + '<li>Hike Attendance and activity report</li>' + '</ul>'
}, {
  date: '2021-08-25',
  version: '1.2.4',
  description: '<ul>' + '<li>Bug fix + Ehancement</li>' + '</ul>'
}, {
  date: '2021-05-21',
  version: '1.2.2',
  description: '<ul><li>Add Rater Assignment feature</li>' + '<li>Bug Fix</li>' + '</ul>'
}, {
  date: '2021-05-01',
  version: '1.2.1',
  description: '<ul><li>Customizable Hike report</li>' + '</ul>'
}, {
  date: '2020-10-11',
  version: '1.2.0',
  description: '<ul><li>Introduce Hike Program</li>' + '</ul>'
}, {
  date: '2020-09-07',
  version: '1.1.7',
  description: '<ul>' + '<li>LHVO-819 Copy event time/ webinar info from event to session</li>' + '<li>LHVO-643 Filterable of timezone and show more item in dropdown list</li>' + '</ul>'
}, {
  date: '2020-08-07',
  version: '1.1.6',
  description: '<ul>' + '<li>LHVO-649 Portal - Add LocalTime in searching Page</li>' + '<li>LHVO-642 Portal: Auto-generate feedback form link</li>' + '<li>LHVO-644 Portal: Copy Event options</li>' + '<li>LHVO-648 Alert for number of participant in the coming days + timezoneList</li>' + '<li>LHVO-645 Portal: Include "Salesforce Opportunity number" in Event Keyword search</li>' + '</ul>'
}, {
  date: '2020-07-27',
  version: '1.1.5',
  description: '<ul>' + '<li>LHVO-604 Search User by UUID</li>' + '<li>LHVO-603 Admin Portal: "Copy Last Session" start time syncing issue</li>' + '<li>LHVO-614 Enhance ILT Keyword Search</li>' + '<li>LHVO-598 Prevent O, 0, 1, l, I in auto-generated password</li>' + '</ul>'
}, {
  date: '2020-06-18',
  version: '1.1.4',
  description: '<ul>' + '<li>LHVO-482 Ability to re-order ILT/VILT resources</li>' + '<li>LHVO-570 Portal: Add white border, maybe instructions, around Activation Code</li>' + '</ul>'
}, {
  date: '2020-01-02',
  version: '1.1.3',
  description: '<ul>' + '<li>Support LifeHikes version 1.1.3 </li>' + '<li>Change page size from 10 to 100</li>' + '<li>Bug Fix baseline flag</li>' + '<li>Bug Fix copy ILT trainig datepicker</li>' + '</ul>'
}];